import { render, staticRenderFns } from "./otherInfo.vue?vue&type=template&id=4777cb1e&scoped=true"
import script from "./otherInfo.vue?vue&type=script&lang=js"
export * from "./otherInfo.vue?vue&type=script&lang=js"
import style0 from "./otherInfo.vue?vue&type=style&index=0&id=4777cb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777cb1e",
  null
  
)

export default component.exports